import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

export interface TitleProps {
  readonly children: React.ReactNode;
  readonly variant?: 'h6' | 'h7';
  readonly sx?: SxProps<Theme>;
}

export const Title: React.FC<TitleProps> = (props: TitleProps): React.ReactElement => {
  const { children, variant = 'h6', sx } = props;

  return (
    <Typography variant={variant} sx={[styles.title, ...(Array.isArray(sx) ? sx : [sx])]}>
      {children}
    </Typography>
  );
};

const styles: Record<string, SystemStyleObject> = {
  title: {
    textAlign: 'center',
  },
};
